import { Flex, Text } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';

export const OverwriteICMJEFormModal = ({
  onClose,
  onSubmit
}: {
  onClose: () => void;
  onSubmit: () => void;
}) => {
  return (
    <Modal
      isOpen
      onClose={onClose}
      width="28rem"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={8} padding={8}>
        <Flex color="actionSecondaryCautionContent">
          <FontAwesomeIcon fontSize={32} icon={faExclamationTriangle} />
        </Flex>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Overwrite Forms and Disclosures?</Text>
          <Text textStyle="textBody">
            This author already has an Forms and Disclosures. Proceeding will
            replace the current form.
          </Text>
        </Flex>
        <Flex gap={2} justifyContent="flex-end">
          <Button onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button onClick={onSubmit} size="regular" variant="caution">
            Proceed
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
